import { HomeOutlined } from "@mui/icons-material";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import ChecklistIcon from '@mui/icons-material/Checklist';
import CreateIcon from '@mui/icons-material/Create';
import DescriptionIcon from '@mui/icons-material/Description';
import FlagCircleIcon from '@mui/icons-material/FlagCircle';
import ListIcon from '@mui/icons-material/List';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import SyncIcon from '@mui/icons-material/Sync';
import { isRoleCheckList } from 'app/utils/appHelpers';
import { useSelector } from 'react-redux';
const MenusComponent = () => {

    const authUser = useSelector(state => state.auth.authUser);


    if (authUser !== null) {
        const userRoles = authUser && authUser.userRoles;

        const menus = [
            {
                label: 'Ana Sayfa',
                type: "nav-item",
                icon: <HomeOutlined sx={{ fontSize: 20 }} />,
                uri: "/"
            },

            isRoleCheckList(userRoles, [1, 373, 369, 370, 371, 372, 416, 418, 375]) ? {
                label: "Yüksek Kurum",
                type: "section",

                children: [
                    isRoleCheckList(userRoles, [1, 370, 373, 371, 418, 375]) ? {
                        uri: "/listMeeting/2",
                        label: 'Yönetim Kurulu Okuma Listesi',
                        type: "nav-item",
                        icon: <ListIcon sx={{ fontSize: 20 }} />,
                    } : "",

                    isRoleCheckList(userRoles, [1, 372]) ? {
                        uri: "/managementMeeting/1",
                        label: 'Yönettiğim Toplantılar',
                        type: "nav-item",
                        icon: <CreateIcon sx={{ fontSize: 20 }} />,
                    } : "",


                    isRoleCheckList(userRoles, [1, 370, 372]) ? {
                        uri: "/addMeetingPage/1",
                        label: 'Toplantı Ekle',
                        type: "nav-item",
                        icon: <AddCircleOutlineIcon sx={{ fontSize: 20 }} />,
                    } : "",


                    isRoleCheckList(userRoles, [1, 373, 369, 370, 372, 416, 375]) ? {

                        uri: "/decisionStatusPage/yk",
                        label: 'YK Uygulanma Durumları',
                        type: "nav-item",
                        icon: <ChecklistIcon sx={{ fontSize: 20 }} />,
                    } : "",


                ]

            } : "",



            isRoleCheckList(userRoles, [1, 373, 368, 369, 417, 375]) ? {

                roleId: 301,
                label: 'Kurul/Komisyon',
                type: "section",

                children: [
                    isRoleCheckList(userRoles, [1, 368, 373, 375]) ? {
                        uri: "/listMeeting/4",
                        label: 'Toplantı Listesi(Okuma)',
                        type: "nav-item",
                        icon: <ListIcon sx={{ fontSize: 20 }} />,
                    } : "",
                    isRoleCheckList(userRoles, [1, 373, 369]) ? {
                        uri: "/managementMeeting/3",
                        label: 'Yönettiğim Toplantılar',
                        type: "nav-item",
                        icon: <CreateIcon sx={{ fontSize: 20 }} />,
                    } : "",
                    isRoleCheckList(userRoles, [1, 373, 369]) ? {
                        uri: "/addMeetingPage/3",
                        label: 'Toplantı Ekle',
                        type: "nav-item",
                        icon: <AddCircleOutlineIcon sx={{ fontSize: 20 }} />,
                    } : "",

                    isRoleCheckList(userRoles, [1, 373, 369, 417]) ? {

                        uri: "/decisionStatusPage/kurul",
                        label: 'Kurul/Komisyon Uygulanma Durumları',
                        type: "nav-item",
                        icon: <ChecklistIcon sx={{ fontSize: 20 }} />,
                    } : "",



                ],

            } : "",

            {
                label: "Toplantı İzleme",
                type: "section",
                children: [
                    {
                        uri: "/watchingMeetingPage",
                        label: 'Toplantı İzleme',
                        type: "nav-item",
                        icon: <SlideshowIcon sx={{ fontSize: 20 }} />,
                    }

                ]

            },
            isRoleCheckList(userRoles, [1, 100, 373, 369, 370, 372, 375]) ? {
                roleId: 301,
                label: 'İşlemlerim',
                type: "section",

                children: [
                    isRoleCheckList(userRoles, [1, 100, 373, 369, 370, 372, 375]) ? {
                        uri: "/attendedMeetings/attented",
                        label: 'Geçmiş Toplantılarım',
                        type: "nav-item",
                        icon: <AssignmentIcon sx={{ fontSize: 20 }} />,
                    } : "",
                    isRoleCheckList(userRoles, [1, 100, 373, 369, 370, 372, 375]) ? {
                        uri: "/attendedMeetings/ongoing",
                        label: 'Devam Eden Toplantılarım',
                        type: "nav-item",
                        icon: <SyncIcon sx={{ fontSize: 20 }} />,
                    } : "",
                    isRoleCheckList(userRoles, [1, 373, 369]) ? {
                        uri: "/uploadPeriodicReportPage",
                        label: 'Rapor Yükle',
                        type: "nav-item",
                        icon: <FlagCircleIcon sx={{ fontSize: 20 }} />,
                    } : "",
                    isRoleCheckList(userRoles, [1, 373, 369, 370, 372]) ? {
                        uri: "/agendaTemplatePage",
                        label: 'Gündem Şablonlarım',
                        type: "nav-item",
                        icon: <BookmarkIcon sx={{ fontSize: 20 }} />,
                    } : ""
                ],

            } : "",


            isRoleCheckList(userRoles, [1, 373, 370, 369, 372, 374, 375, 416, 417]) ? {
                label: "Yönetim",
                type: "section",
                roleId: 303,
                children: [
                    isRoleCheckList(userRoles, [1, 373, 370, 369, 372]) ? {
                        label: 'Tanımlamalar',
                        type: "collapsible",
                        icon: <ManageAccountsIcon sx={{ fontSize: 20 }} />,
                        children: [
                            isRoleCheckList(userRoles, [1, 373, 370, 369]) ? {
                                uri: "/listUnit",
                                label: 'Kurul/Kol/Komisyon',
                                type: "nav-item",
                            } : "",
                            isRoleCheckList(userRoles, [1, 373, 370, 372]) ? {
                                uri: "/listSubject",
                                label: 'Konular',
                                type: "nav-item",
                            } : "",

                            isRoleCheckList(userRoles, [1, 370]) ? {
                                uri: "/CustomEpostaListPage",
                                label: 'Özel E-Posta Listesi',
                                type: "nav-item",
                            } : "",
                            isRoleCheckList(userRoles, [1, 373, 370, 369, 372, 416, 417]) ? {
                                uri: "/listAnnouncement",
                                label: 'Duyurular',
                                type: "nav-item",
                            } : "",
                        ]
                    } : "",
                    isRoleCheckList(userRoles, [1, 373, 370, 369, 372]) ? {
                        label: 'Yetkiler',
                        type: "collapsible",
                        icon: <ManageAccountsIcon sx={{ fontSize: 20 }} />,
                        children: [
                            isRoleCheckList(userRoles, [1, 373, 370]) ? {
                                uri: "/RoleManagementPage",
                                label: 'Rol Yönetimi',
                                type: "nav-item",
                            } : "",
                            isRoleCheckList(userRoles, [1, 373, 370, 369, 372]) ? {
                                uri: "/RoleUserParticipantManPage",
                                label: 'Üye/Katılımcı Yetkisi',
                                type: "nav-item",
                            } : "",
                            isRoleCheckList(userRoles, [1, 373, 370]) ? {
                                uri: "/RoleDstatusPage",
                                label: 'Uygulanma Durumu Yetkisi',
                                type: "nav-item",
                            } : "",
                            isRoleCheckList(userRoles, [1, 373, 370]) ? {
                                uri: "/RoleReportingPage",
                                label: 'Raporlama Yetkisi',
                                type: "nav-item",
                            } : ""
                        ]
                    } : "",
                    isRoleCheckList(userRoles, [1, 373, 370, 369, 372, 374, 375, 416]) ? {
                        label: 'Raporlar',
                        type: "collapsible",
                        icon: <DescriptionIcon sx={{ fontSize: 20 }} />,
                        children: [
                            isRoleCheckList(userRoles, [1, 373, 370, 369, 372, 375]) ? {
                                uri: "/reportSubjectGroupsPage",
                                label: 'Kararların Konularına Göre Dağılımı',
                                type: "nav-item",
                            } : "",
                            isRoleCheckList(userRoles, [1, 373, 370, 369, 372, 375]) ? {
                                uri: "/reportDecisionCountInfoPage",
                                label: 'Kararların İstatistik Bilgileri',
                                type: "nav-item",
                            } : "",
                            isRoleCheckList(userRoles, [1, 373, 370, 369, 372, 375]) ? {
                                uri: "/reportMeetingUsersInfoPage",
                                label: 'Toplantı Üye Bilgileri',
                                type: "nav-item",
                            } : "",
                            isRoleCheckList(userRoles, [1, 373, 370, 369, 372, 374, 375]) ? {
                                uri: "/reportUnitCountPage",
                                label: 'Kurul/Kol/Komisyonların Toplantı Sayısı',
                                type: "nav-item",
                            } : "",
                            isRoleCheckList(userRoles, [1, 373, 370, 369, 372, 374, 375]) ? {
                                uri: "/reportBoardMemberPage",
                                label: 'Üye Aylık Toplantı Sayıları',
                                type: "nav-item",
                            } : "",
                            isRoleCheckList(userRoles, [1, 373, 370]) ? {
                                uri: "/reportAuthorityListPage",
                                label: 'Yetki Listesi',
                                type: "nav-item",
                            } : "",
                            isRoleCheckList(userRoles, [1, 373, 370, 369, 372, 374, 375, 416]) ? {
                                uri: "/reportYKKPage",
                                label: 'YKK Rapor',
                                type: "nav-item",
                            } : ""
                        ]
                    } : "",
                ]
            } : "",

            {
                label: "Eğitim",
                type: "section",

                children: [
                    {
                        uri: "/educationVideosPage",
                        label: 'Eğitim Videoları',
                        type: "nav-item",
                        icon: <ListIcon sx={{ fontSize: 20 }} />,

                    }


                ]

            }


        ];
        return menus;
    }
    return [];
};


export default MenusComponent;
